/*
 * Gates visibility of the GTM-injected Kustomer chat widget (prod only). The
 * Web SDK v2 has no runtime show/hide method, so we toggle a <body> class that
 * a CSS rule (src/index.scss) uses to hide/show the widget. Revealed only while
 * the footer is in view, except: the `kustomerchat` campaign UTM, or an open
 * conversation, keep it visible regardless of scroll.
 */

const BODY_CLASS = 'kustomer-at-footer';

let footerVisible = false;
let chatOpen = false;
let listenersAttached = false;

// Loose match — the exact GTM UTM key is ambiguous (utm_source vs utm_course).
const hasCampaignDeepLink = () => {
  try {
    return window.location.search.toLowerCase().includes('kustomerchat');
  } catch (e) {
    return false;
  }
};

const syncBodyClass = () => {
  if (typeof document === 'undefined' || !document.body) {
    return;
  }
  const shouldShow = footerVisible || chatOpen || hasCampaignDeepLink();
  document.body.classList.toggle(BODY_CLASS, shouldShow);
};

// Widget is started by GTM and may not exist yet; no-op until it does.
const attachChatStateListeners = () => {
  if (listenersAttached) {
    return;
  }
  const kustomer = window.Kustomer;
  if (!kustomer || typeof kustomer.addListener !== 'function') {
    return;
  }
  listenersAttached = true;
  kustomer.addListener('onOpen', () => {
    chatOpen = true;
    syncBodyClass();
  });
  kustomer.addListener('onClose', () => {
    chatOpen = false;
    syncBodyClass();
  });
};

const KustomerChat = {
  init() {
    syncBodyClass();
    attachChatStateListeners();
  },

  setFooterVisible(isVisible) {
    footerVisible = Boolean(isVisible);
    // Widget is reliably started by the time the footer shows — retry here.
    if (footerVisible) {
      attachChatStateListeners();
    }
    syncBodyClass();
  },
};

export default KustomerChat;
